export default __webpack_public_path__ + "static/media/slider_7-xs@1x.c7c6f0fd.jpg";